<template>
  <a-form-model
    ref="addReportForm"
    :form="form"
    :model="form"
    @submit="handleSubmit"
    @submit.native.prevent
  >
    <div class="w-full flex">
      <a-form-model-item label="Year" prop="year" class="mr-4 flex-1">
        <a-select v-model="form.year">
          <a-select-option v-for="year in years" :key="year" :value="year">
            {{ year }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="Month" prop="month" class="flex-1">
        <a-select v-model="form.month">
          <a-select-option
            v-for="month in months"
            :key="month.value"
            :value="month.value"
          >
            {{ month.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </div>
    <div class="w-full flex">
      <a-form-model-item
        :label="'Total assets (' + fund.currency + ')'"
        class="mr-4 flex-1"
        prop="totalAssets"
      >
        <a-input-number v-model="form.totalAssets" class="w-full" />
      </a-form-model-item>
      <a-form-model-item
        :label="'Total investments (' + fund.currency + ')'"
        class="flex-1"
        prop="totalInvestments"
      >
        <a-input-number v-model="form.totalInvestments" class="w-full" />
      </a-form-model-item>
    </div>
    <div
      v-for="(classReport, index) in form.classReports"
      :key="classReport.id"
    >
      <h3 class="text-2xl font-semibold">{{ classReport.className }}</h3>
      <div class="w-full flex">
        <a-form-model-item
          :label="'Share value (' + classReport.classCurrency + ')'"
          :prop="'classReports.' + index + '.shareValue'"
          class="mr-4 flex-1"
        >
          <a-input-number v-model="classReport.shareValue" class="w-full" />
        </a-form-model-item>
        <a-form-model-item
          :label="'Dividend (' + classReport.classCurrency + ')'"
          :prop="'classReports.' + index + '.dividend'"
          class="flex-1"
        >
          <a-input-number v-model="classReport.dividend" class="w-full" />
        </a-form-model-item>
      </div>
    </div>
    <a-button type="primary" html-type="submit" :disabled="isSaving">
      Save
    </a-button>
    <a-button class="ml-4" @click="onCancelButtonClicked()">
      Cancel
    </a-button>
  </a-form-model>
</template>

<script>
import gql from 'graphql-tag'
import months from '../../data/Months'

export default {
  props: {
    fund: {
      type: Object,
      required: true,
    },
    classes: {
      type: Array,
      required: true,
    },
    selectedYear: {
      type: Number,
    },
    selectedMonth: {
      type: Number,
    },
  },
  data() {
    return {
      form: {
        year: this.selectedYear ?? new Date().getFullYear(),
        month: this.selectedMonth ?? new Date().getMonth() + 1,
        totalAssets: null,
        totalInvestments: null,
        classReports: [],
      },
      months,
      isSaving: false,
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
    years() {
      let year = 2003
      let result = []
      while (year <= this.currentYear) {
        result.push(year)
        year++
      }
      return result
    },
  },
  methods: {
    initializeClassReports() {
      this.form.classReports = []
      for (let fundClass of this.classes) {
        this.form.classReports.push({
          classId: fundClass.key,
          className: fundClass.name,
          classCurrency: fundClass.currency,
          shareValue: null,
          dividend: null,
        })
      }
    },
    handleSubmit() {
      this.$refs.addReportForm.validate(async (valid) => {
        if (valid) {
          try {
            this.isSaving = true
            await this.$apollo.mutate({
              mutation: gql`
                mutation($input: AddFundMonthlyReportInput) {
                  addFundMonthlyReport(input: $input) {
                    reportId
                  }
                }
              `,
              variables: {
                input: {
                  fundId: this.fund.key,
                  fundName: this.fund.name,
                  fundCurrency: this.fund.currency,
                  year: this.form.year,
                  month: this.form.month,
                  totalAssets: this.form.totalAssets,
                  totalInvestments: this.form.totalInvestments,
                  classReports: this.form.classReports.map((r) => ({
                    classId: r.classId,
                    className: r.className,
                    classCurrency: r.classCurrency,
                    shareValue: r.shareValue,
                    dividend: r.dividend,
                  })),
                },
              },
            })
            this.isSaving = false
            this.$refs.addReportForm.resetFields()
            this.$emit('reportSaved', {
              year: this.form.year,
              month: this.form.month,
            })
          } catch (error) {
            this.$message.error(error.message)
            this.isSaving = false
          }
        } else {
          return false
        }
      })
    },
    onCancelButtonClicked() {
      this.$emit('cancelButtonClicked')
      this.$refs.addReportForm.resetFields()
    },
  },
  created() {
    this.initializeClassReports()
  },
  watch: {
    fund() {
      this.initializeClassReports()
    },
  },
}
</script>

<style></style>
